import { Component, OnInit } from '@angular/core';
import {SectionBase} from '../../../components/section/section-base';
import {InsurerDataConsts} from '../../../../core/consts/insurer-data.consts';
import {SeparateInsurerDataSectionConfig} from './separate-insurer-data-section.config';
import {InsurerDataFormStateService} from '../../../../core/services/impl/section-services/insurer-data/insurer-data-form-state.service';
import {SeparateInsurerDataService} from '../../../../core/services/impl/section-services/separate-insurer-data/separate-insurer-data.service';
import {ControlChange} from '../../../../core/models/control-change.model';
import {RegExpService} from '../../../services/reg-exp.service';

@Component({
  selector: 'app-separate-insurer-data-section',
  templateUrl: './separate-insurer-data-section.component.html',
  styleUrls: []
})
export class SeparateInsurerDataSectionComponent extends SectionBase implements OnInit {

  public consts = InsurerDataConsts;
  public config: SeparateInsurerDataSectionConfig = new SeparateInsurerDataSectionConfig(this.regExpService);
  title = 'SEPARATE_INSURER_DATA_SECTION.title';

  constructor(public stateService: InsurerDataFormStateService,
              private separateInsurerDataService: SeparateInsurerDataService,
              private regExpService: RegExpService) {
    super();
  }

  ngOnInit() {
    this.initBean();
    this.createConfig();
    this.buildForm();
    this.initControlsChanges();
  }

  createConfig(): void {
    this.formConfig = this.config.createConfig();
  }

  initBean(): void {
    this.bean = this.stateService.insurerRegistrationData;
  }

  initControlsChanges(): void {
    let controls: ControlChange[] = [
      {
        controlName: InsurerDataConsts.FIRST_NAME,
        behaviour: value => this.separateInsurerDataService.changeFirstName(value)
      },
      {
        controlName: InsurerDataConsts.LAST_NAME,
        behaviour: value => this.separateInsurerDataService.changeLastName(value)
      },
      {
        controlName: InsurerDataConsts.PESEL,
        behaviour: value => this.separateInsurerDataService.changePesel(value)
      },
      {
        controlName: InsurerDataConsts.POSTAL_CODE,
        behaviour: value => this.separateInsurerDataService.changePostalCode(value)
      },
      {
        controlName: InsurerDataConsts.CITY,
        behaviour: value => this.separateInsurerDataService.changeCity(value)
      },
      {
        controlName: InsurerDataConsts.STREET,
        behaviour: value => this.separateInsurerDataService.changeStreet(value)
      },
      {
        controlName: InsurerDataConsts.BUILDING_NUMBER,
        behaviour: value => this.separateInsurerDataService.changeBuildingNumber(value)
      },
      {
        controlName: InsurerDataConsts.FLAT_NUMBER,
        behaviour: value => this.separateInsurerDataService.changeFlatNumber(value)
      }
    ];

    this.handleControlsState(...controls);
  }

}
